import { IDataGLBRenderObject } from "../../../../services/api/3d/GLBApi/type";
import { ObjectService } from "../../../../services/ObjectService";
import { stateT } from "../../types";
import { ISelectItemObjectData } from "../uiTypes";
import {
  getProductByIdAndPath,
  getCurrentCategoryFolder,
  getProductFromCache,
} from "./objectSelectors";

export const getDataProductForGetGlbById =
  (productId: string, selectData: ISelectItemObjectData) =>
  (state: stateT): IDataGLBRenderObject => {
    const { pathObjectIds, geometryOptions, realId, projectId } = selectData;

    // First try to get product from currentCategoryFolder (has fetched products)
    const currentCategoryFolder = getCurrentCategoryFolder(state);
    const projectInFolder = currentCategoryFolder?.projects?.find(
      p => p.id === projectId
    );
    const productFromFolder = projectInFolder?.availableProducts?.find(
      p => p.id === realId
    );

    // Next try the cache by project
    const productFromCache = getProductFromCache(projectId, realId)(state);

    // Fallback to path-based lookup
    const productFromPath = getProductByIdAndPath(
      realId,
      pathObjectIds,
      projectId
    )(state);

    const product = productFromFolder || productFromCache || productFromPath;

    if (!product) {
      throw new Error(`Product with id ${productId} not found`);
    }
    const { REACT_APP_NODE_ENV_KEY } = process.env;

    return {
      organizationId: REACT_APP_NODE_ENV_KEY === "production" ? 16 : 16, // hardcoded for now
      config: {
        lod: 1, // LOD (Level of Detail) hardcoded value
        type: "glb",
        format: null,
        quality: null,
        texture: null,
        products: [
          {
            id: product.id,
            name: product.name,
            projectId: product.projectId,
            paramString: product.paramString,
            resourceUrl: product.resource ?? null,
            options: [
              ...ObjectService.getOptionsByProductAndSelectData(
                "geometry",
                product,
                geometryOptions
              ),
            ],
          },
        ],
        resolution: null,
        includeMaterials: false,
      },
    };
  };
